import { render, staticRenderFns } from "./GButton.vue?vue&type=template&id=5457ba8a&scoped=true&"
import script from "./GButton.vue?vue&type=script&lang=ts&"
export * from "./GButton.vue?vue&type=script&lang=ts&"
import style0 from "./GButton.vue?vue&type=style&index=0&id=5457ba8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5457ba8a",
  null
  
)

export default component.exports